// extracted by mini-css-extract-plugin
module.exports = {"heroBanner":"HomeBanner_heroBanner__M_TGY","mobile":"HomeBanner_mobile__5Ini0","desktop":"HomeBanner_desktop__Sas03"};